
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PUTTBDHUNDREDPOINTS_ACTION,
    ALL_PUTTBDHUNDREDPOINTS,
    ADD_PUTTBDHUNDREDPOINTS,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Putt broadie Drill 100FT Actions
 */

    export const stdBDHundredPoints = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTBDHUNDREDPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtbdhundredpoint', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data;
                
                dispatch({ type: ALL_PUTTBDHUNDREDPOINTS, payload: alldata.data }); 
                return Promise.resolve(alldata);
            });
        
        }
    }

    export const addBDHundredPoints = (student, startdate, enddate, data, sepmore) =>{
        
        var payload={
            "startdate":startdate,
            "enddate":enddate,
            "totval":1,
            "student":student,
            "shtot_1":sepmore,
        }
        

        for (let i = 0; i<sepmore; i++) {   
           
            var putdate='puttdate_'+i;            
            var putdateval=data.target[putdate].value;
            var putpoint='noputt_'+i;            
            var putpointval=data.target[putpoint].value;                   
            
            var adval=i+1;            
            var dateadd='puttdate_1_'+adval;  
            var puttadd='noputt_1_'+adval;             
           
            payload[dateadd]=putdateval;
            payload[puttadd]=putpointval;          
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTBDHUNDREDPOINTS_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtbdhundredpoint', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                   
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTBDHUNDREDPOINTS});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

   

